import React, { useState, useEffect } from 'react';
import './NewCodigo.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import Swal from 'sweetalert2';

export default function NewCodigo({ cuponEditar, onCerrar, onActualizar }) {
    const [mensaje, setMensaje] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    
    // Estados del formulario - Sección 1
    const [codigo, setCodigo] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [tipoDescuento, setTipoDescuento] = useState('porcentaje');
    const [valorDescuento, setValorDescuento] = useState('');
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [estado, setEstado] = useState('activo');
    
    // Estados del formulario - Sección 2
    const [limiteUsosActivo, setLimiteUsosActivo] = useState(false);
    const [limiteUsos, setLimiteUsos] = useState('');
    const [montoMinimo, setMontoMinimo] = useState('');
    
    // Estados del formulario - Sección 3
    const [aplicarA, setAplicarA] = useState('todos');
    const [categoriasSeleccionadas, setCategoriasSeleccionadas] = useState([]);
    const [productosSeleccionados, setProductosSeleccionados] = useState([]);
    
    // Estados para cargar datos
    const [categorias, setCategorias] = useState([]);
    const [productos, setProductos] = useState([]);
    
    useEffect(() => {
        if (modalOpen) {
            cargarCategorias();
            cargarProductos();
        }
    }, [modalOpen]);
    
    useEffect(() => {
        if (cuponEditar && modalOpen) {
            cargarDatosCupon(cuponEditar);
        }
    }, [cuponEditar, modalOpen]);
    
    const cargarCategorias = async () => {
        try {
            const response = await fetch(`${baseURL}/categoriasGet.php`);
            const data = await response.json();
            setCategorias(data.categorias || []);
        } catch (error) {
            console.error('Error al cargar categorías:', error);
        }
    };
    
    const cargarProductos = async () => {
        try {
            const response = await fetch(`${baseURL}/productosGet.php`);
            const data = await response.json();
            setProductos(data.productos || []);
        } catch (error) {
            console.error('Error al cargar productos:', error);
        }
    };
    
    const cargarDatosCupon = async (idCodigo) => {
        try {
            const response = await fetch(`${baseURL}/codigosGet.php?idCodigo=${idCodigo}`);
            const data = await response.json();
            
            if (data.success && data.cupon) {
                const cupon = data.cupon;
                setCodigo(cupon.codigo);
                setDescripcion(cupon.descripcion);
                setTipoDescuento(cupon.tipo_descuento);
                setValorDescuento(cupon.valor_descuento);
                setFechaInicio(cupon.fecha_inicio || '');
                setFechaFin(cupon.fecha_fin || '');
                setEstado(cupon.estado);
                
                if (cupon.limite_usos !== null) {
                    setLimiteUsosActivo(true);
                    setLimiteUsos(cupon.limite_usos);
                }
                
                setMontoMinimo(cupon.monto_minimo || '');
                setAplicarA(cupon.aplicar_a);
                setCategoriasSeleccionadas(cupon.categorias || []);
                setProductosSeleccionados(cupon.productos || []);
            }
        } catch (error) {
            console.error('Error al cargar datos del cupón:', error);
        }
    };
    
    const toggleModal = () => {
        if (modalOpen) {
            limpiarFormulario();
            if (onCerrar) onCerrar();
        }
        setModalOpen(!modalOpen);
    };
    
    const limpiarFormulario = () => {
        setCodigo('');
        setDescripcion('');
        setTipoDescuento('porcentaje');
        setValorDescuento('');
        setFechaInicio('');
        setFechaFin('');
        setEstado('activo');
        setLimiteUsosActivo(false);
        setLimiteUsos('');
        setMontoMinimo('');
        setAplicarA('todos');
        setCategoriasSeleccionadas([]);
        setProductosSeleccionados([]);
        setMensaje('');
    };
    
    const generarCodigoAleatorio = () => {
        const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let codigoAleatorio = '';
        for (let i = 0; i < 8; i++) {
            codigoAleatorio += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
        }
        return codigoAleatorio;
    };
    
    const validarFormulario = () => {
        if (!codigo.trim()) {
            toast.error('El código es requerido');
            return false;
        }
        
        if (/\s/.test(codigo)) {
            toast.error('El código no puede contener espacios');
            return false;
        }
        
        if (!descripcion.trim()) {
            toast.error('La descripción es requerida');
            return false;
        }
        
        if (!valorDescuento || parseFloat(valorDescuento) <= 0) {
            toast.error('El valor del descuento debe ser mayor a 0');
            return false;
        }
        
        if (tipoDescuento === 'porcentaje' && parseFloat(valorDescuento) > 100) {
            toast.error('El porcentaje no puede ser mayor a 100');
            return false;
        }
        
        if (fechaInicio && fechaFin && new Date(fechaFin) <= new Date(fechaInicio)) {
            toast.error('La fecha de fin debe ser mayor a la fecha de inicio');
            return false;
        }
        
        if (limiteUsosActivo && (!limiteUsos || parseInt(limiteUsos) <= 0)) {
            toast.error('El límite de usos debe ser mayor a 0');
            return false;
        }
        
        if (aplicarA === 'categorias' && categoriasSeleccionadas.length === 0) {
            toast.error('Debe seleccionar al menos una categoría');
            return false;
        }
        
        if (aplicarA === 'productos' && productosSeleccionados.length === 0) {
            toast.error('Debe seleccionar al menos un producto');
            return false;
        }
        
        return true;
    };
    
    const handleSubmit = async () => {
        if (!validarFormulario()) return;
        
        setMensaje('Procesando...');
        
        const dataCupon = {
            codigo: codigo.trim().toUpperCase(),
            descripcion: descripcion.trim(),
            tipo_descuento: tipoDescuento,
            valor_descuento: parseFloat(valorDescuento),
            fecha_inicio: fechaInicio || null,
            fecha_fin: fechaFin || null,
            limite_usos: limiteUsosActivo ? parseInt(limiteUsos) : null,
            monto_minimo: montoMinimo ? parseFloat(montoMinimo) : null,
            aplicar_a: aplicarA,
            estado: estado,
            categorias: aplicarA === 'categorias' ? categoriasSeleccionadas : [],
            productos: aplicarA === 'productos' ? productosSeleccionados : []
        };
        
        try {
            let url = `${baseURL}/codigosPost.php`;
            let method = 'POST';
            
            if (cuponEditar) {
                url = `${baseURL}/codigosPut.php?idCodigo=${cuponEditar}`;
                method = 'PUT';
            }
            
            const response = await fetch(url, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataCupon),
            });
            
            const data = await response.json();
            
            if (data.success || data.mensaje) {
                setMensaje('');
                toast.success(data.mensaje);
                limpiarFormulario();
                toggleModal();
                if (onActualizar) onActualizar();
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');
        }
    };
    
    const handleCategoriaChange = (idCategoria) => {
        setCategoriasSeleccionadas(prev => {
            if (prev.includes(idCategoria)) {
                return prev.filter(id => id !== idCategoria);
            } else {
                return [...prev, idCategoria];
            }
        });
    };
    
    const handleProductoChange = (idProducto) => {
        setProductosSeleccionados(prev => {
            if (prev.includes(idProducto)) {
                return prev.filter(id => id !== idProducto);
            } else {
                return [...prev, idProducto];
            }
        });
    };
    
    // Si se está editando, abrir el modal automáticamente
    useEffect(() => {
        if (cuponEditar) {
            setModalOpen(true);
        }
    }, [cuponEditar]);
    
    return (
        <div className='NewContain'>
            <ToastContainer />
            {!cuponEditar && (
                <button onClick={toggleModal} className='btnSave'>
                    <span>+</span> Agregar Cupón
                </button>
            )}
            
            {modalOpen && (
                <div className='modal cupon-modal'>
                    <div className='modal-content cupon-modal-content'>
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>
                                {cuponEditar ? 'Editar Cupón' : 'Agregar Cupón'}
                            </button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        
                        <form id="cuponForm" className='cupon-form'>
                            {/* SECCIÓN 1: Información Básica */}
                            <div className='form-section'>
                                <h3 className='section-title'>Información Básica</h3>
                                
                                <div className='form-row'>
                                    <fieldset className='field-50'>
                                        <legend>Código del cupón *</legend>
                                        <div className='input-with-button'>
                                            <input
                                                type='text'
                                                value={codigo}
                                                onChange={(e) => setCodigo(e.target.value.toUpperCase())}
                                                placeholder='Ej: VERANO20'
                                            />
                                            <button 
                                                type='button' 
                                                className='btn-generar'
                                                onClick={() => setCodigo(generarCodigoAleatorio())}
                                            >
                                                Generar
                                            </button>
                                        </div>
                                    </fieldset>
                                    
                                    <fieldset className='field-50'>
                                        <legend>Estado *</legend>
                                        <select value={estado} onChange={(e) => setEstado(e.target.value)}>
                                            <option value='activo'>Activo</option>
                                            <option value='inactivo'>Inactivo</option>
                                        </select>
                                    </fieldset>
                                </div>
                                
                                <fieldset>
                                    <legend>Descripción interna *</legend>
                                    <input
                                        type='text'
                                        value={descripcion}
                                        onChange={(e) => setDescripcion(e.target.value)}
                                        placeholder='Descripción para uso interno'
                                    />
                                </fieldset>
                                
                                <div className='form-row'>
                                    <fieldset className='field-50'>
                                        <legend>Tipo de descuento *</legend>
                                        <select 
                                            value={tipoDescuento} 
                                            onChange={(e) => setTipoDescuento(e.target.value)}
                                        >
                                            <option value='porcentaje'>Porcentaje (%)</option>
                                            <option value='monto_fijo'>Monto fijo ($)</option>
                                        </select>
                                    </fieldset>
                                    
                                    <fieldset className='field-50'>
                                        <legend>
                                            Valor del descuento * 
                                            {tipoDescuento === 'porcentaje' ? ' (%)' : ' ($)'}
                                        </legend>
                                        <input
                                            type='number'
                                            step='0.01'
                                            min='0'
                                            max={tipoDescuento === 'porcentaje' ? '100' : undefined}
                                            value={valorDescuento}
                                            onChange={(e) => setValorDescuento(e.target.value)}
                                            placeholder={tipoDescuento === 'porcentaje' ? 'Ej: 20' : 'Ej: 5000'}
                                        />
                                    </fieldset>
                                </div>
                                
                                <div className='form-row'>
                                    <fieldset className='field-50'>
                                        <legend>Fecha de inicio</legend>
                                        <input
                                            type='datetime-local'
                                            value={fechaInicio}
                                            onChange={(e) => setFechaInicio(e.target.value)}
                                        />
                                    </fieldset>
                                    
                                    <fieldset className='field-50'>
                                        <legend>Fecha de fin</legend>
                                        <input
                                            type='datetime-local'
                                            value={fechaFin}
                                            onChange={(e) => setFechaFin(e.target.value)}
                                        />
                                    </fieldset>
                                </div>
                            </div>
                            
                            {/* SECCIÓN 2: Límites de Uso */}
                            <div className='form-section'>
                                <h3 className='section-title'>Límites de Uso</h3>
                                
                                <div className='toggle-container'>
                                    <label className='toggle-label'>
                                        <input
                                            type='checkbox'
                                            checked={limiteUsosActivo}
                                            onChange={(e) => {
                                                setLimiteUsosActivo(e.target.checked);
                                                if (!e.target.checked) setLimiteUsos('');
                                            }}
                                        />
                                        <span>Limitar cantidad de usos</span>
                                    </label>
                                </div>
                                
                                {limiteUsosActivo && (
                                    <fieldset>
                                        <legend>Cantidad máxima de usos</legend>
                                        <input
                                            type='number'
                                            min='1'
                                            value={limiteUsos}
                                            onChange={(e) => setLimiteUsos(e.target.value)}
                                            placeholder='Ej: 100'
                                        />
                                    </fieldset>
                                )}
                                
                                <fieldset>
                                    <legend>Monto mínimo de compra ($)</legend>
                                    <input
                                        type='number'
                                        step='0.01'
                                        min='0'
                                        value={montoMinimo}
                                        onChange={(e) => setMontoMinimo(e.target.value)}
                                        placeholder='Opcional. Ej: 50000'
                                    />
                                </fieldset>
                            </div>
                            
                            {/* SECCIÓN 3: Aplicabilidad */}
                            <div className='form-section'>
                                <h3 className='section-title'>Aplicabilidad</h3>
                                
                                <div className='radio-group'>
                                    <label className='radio-label'>
                                        <input
                                            type='radio'
                                            name='aplicar_a'
                                            value='todos'
                                            checked={aplicarA === 'todos'}
                                            onChange={(e) => setAplicarA(e.target.value)}
                                        />
                                        <span>Aplicar a todos los productos</span>
                                    </label>
                                    
                                    <label className='radio-label'>
                                        <input
                                            type='radio'
                                            name='aplicar_a'
                                            value='categorias'
                                            checked={aplicarA === 'categorias'}
                                            onChange={(e) => setAplicarA(e.target.value)}
                                        />
                                        <span>Aplicar a categorías específicas</span>
                                    </label>
                                    
                                    <label className='radio-label'>
                                        <input
                                            type='radio'
                                            name='aplicar_a'
                                            value='productos'
                                            checked={aplicarA === 'productos'}
                                            onChange={(e) => setAplicarA(e.target.value)}
                                        />
                                        <span>Aplicar a productos específicos</span>
                                    </label>
                                </div>
                                
                                {aplicarA === 'categorias' && (
                                    <div className='selection-container'>
                                        <p className='selection-title'>Seleccione las categorías:</p>
                                        <div className='checkbox-list'>
                                            {categorias.map(cat => (
                                                <label key={cat.idCategoria} className='checkbox-label'>
                                                    <input
                                                        type='checkbox'
                                                        checked={categoriasSeleccionadas.includes(cat.idCategoria)}
                                                        onChange={() => handleCategoriaChange(cat.idCategoria)}
                                                    />
                                                    <span>{cat.categoria}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                
                                {aplicarA === 'productos' && (
                                    <div className='selection-container'>
                                        <p className='selection-title'>Seleccione los productos:</p>
                                        <div className='checkbox-list products-list'>
                                            {productos.map(prod => (
                                                <label key={prod.idProducto} className='checkbox-label'>
                                                    <input
                                                        type='checkbox'
                                                        checked={productosSeleccionados.includes(prod.idProducto)}
                                                        onChange={() => handleProductoChange(prod.idProducto)}
                                                    />
                                                    <span>{prod.titulo}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                            
                            {/* Botones de acción */}
                            <div className='form-actions'>
                                {mensaje ? (
                                    <button type='button' className='btnLoading' disabled>
                                        {mensaje}
                                    </button>
                                ) : (
                                    <>
                                        <button type='button' onClick={handleSubmit} className='btnPost'>
                                            {cuponEditar ? 'Actualizar Cupón' : 'Crear Cupón'}
                                        </button>
                                        <button type='button' onClick={toggleModal} className='btnCancel'>
                                            Cancelar
                                        </button>
                                    </>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
